const RETURN_CART_SESSION_KEY = "return_cart_context_v1";

const canUseSessionStorage = () =>
  typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";

export function saveReturnCartContext(context) {
  if (!canUseSessionStorage()) {
    return;
  }

  const payload = {
    selectedOrder: context?.selectedOrder || null,
    returnedProducts: Array.isArray(context?.returnedProducts)
      ? context.returnedProducts
      : [],
    shipmentMethod: context?.shipmentMethod || "",
    refundSource:
      context?.refundSource === undefined ? null : context.refundSource,
    refundJSON: context?.refundJSON || {},
    addressDetails: context?.addressDetails || null,
    uploadMediaIds: Array.isArray(context?.uploadMediaIds)
      ? context.uploadMediaIds
      : [],
    uniqueId: context?.uniqueId || "",
    customerContact: context?.customerContact || null,
    savedAt: Date.now(),
  };

  try {
    window.sessionStorage.setItem(
      RETURN_CART_SESSION_KEY,
      JSON.stringify(payload),
    );
  } catch (_) {}
}

export function getReturnCartContext() {
  if (!canUseSessionStorage()) {
    return null;
  }

  try {
    const rawValue = window.sessionStorage.getItem(RETURN_CART_SESSION_KEY);

    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);
    return parsedValue && typeof parsedValue === "object" ? parsedValue : null;
  } catch (_) {
    return null;
  }
}

export function mergeReturnCartContext(partialContext) {
  const currentContext = getReturnCartContext() || {};
  saveReturnCartContext({
    ...currentContext,
    ...partialContext,
  });
}

export function clearReturnCartContext() {
  if (!canUseSessionStorage()) {
    return;
  }

  try {
    window.sessionStorage.removeItem(RETURN_CART_SESSION_KEY);
  } catch (_) {}
}
